<template>
  <div class="languages-card">
    <h4 class="languages-card__title">{{ $t('page.about.languagesCard.title') }}</h4>
    <div class="languages-card__list">
      <div
        v-for="language in languages"
        :key="language.name"
        class="language-item"
        @mouseenter="activeLanguage = language.name"
        @mouseleave="activeLanguage = null"
        :class="{ 'is-active': activeLanguage === language.name }"
      >
        <span class="language-flag">{{ language.flag }}</span>
        <div class="language-info">
          <span class="language-name">{{ language.name }}</span>
          <span class="language-level">{{ language.level }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const activeLanguage = ref(null)

const languages = computed(() => [
  {
    name: t('page.about.languagesCard.items.0.name'),
    flag: '🇪🇸',
    level: t('page.about.languagesCard.items.0.level'),
  },
  {
    name: t('page.about.languagesCard.items.1.name'),
    flag: '🇧🇷',
    level: t('page.about.languagesCard.items.1.level'),
  },
  {
    name: t('page.about.languagesCard.items.2.name'),
    flag: '🇺🇸',
    level: t('page.about.languagesCard.items.2.level'),
  },
])
</script>

<style scoped>
.languages-card {
  @apply p-4 h-full flex flex-col;
}

.languages-card__title {
  @apply text-xs uppercase tracking-wider mb-3;
  color: var(--color-text-muted);
}

.languages-card__list {
  @apply flex flex-col gap-2 flex-1;
}

.language-item {
  @apply flex items-center gap-3 p-2 rounded-xl;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: default;
}

.language-flag {
  @apply text-xl flex-shrink-0;
}

.language-info {
  @apply flex flex-col min-w-0 flex-1;
}

.language-name {
  @apply text-sm font-medium;
  color: var(--color-text-primary);
}

.language-level {
  @apply text-xs;
  color: var(--color-text-muted);
}
</style>
